import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { logger } from '~portal/lib';
import { type FilesSearchPatch, parseFilesSearch, withFilesSearch } from '~portal/lib/files-search';
import { FilesPage } from './-files';

/**
 * @desc The admin Files page (`add-admin-files-search`): staff search the file catalogue by title,
 * file name or contents. Every filter lives in the URL (`parseFilesSearch`) so a view can be shared.
 */
export const Route = createFileRoute('/_protected/admin/files')({
  validateSearch: parseFilesSearch,
  component: AdminFilesPage,
});

function AdminFilesPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const update = (patch: FilesSearchPatch) => {
    navigate({ search: (prev) => withFilesSearch(prev, patch), resetScroll: false }).catch(
      (err) => {
        logger.error('[AdminFiles] Navigation failed', {
          error: err instanceof Error ? err.message : String(err),
        });
      },
    );
  };

  return <FilesPage search={search} onSearch={update} />;
}
